class ColourSwatches extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['item']
  }

  activeColour = ''

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)
    this.handlePointerEnter = this.handlePointerEnter.bind(this)
    this.handlePointerLeave = this.handlePointerLeave.bind(this)

    this.els.item.elements.forEach((item) => {
      this.listeners.add(item, 'click', this.handleClick)
      this.listeners.add(item, 'pointerenter', this.handlePointerEnter)
    })

    this.listeners.add(this, 'pointerleave', this.handlePointerLeave)
  }

  handleClick (event) {
    const item = event.currentTarget

    event.preventDefault()

    if (item.getAttribute('aria-current') === 'true') return

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_SELECTED, {
      event,
      target: item,
      selectedOptionValues: [],
    })
  }

  handlePointerEnter (event) {
    if (!window.BAO.MediaBreakpoints.isMd) return

    this.setPreview(event.currentTarget.dataset.colour)
  }

  handlePointerLeave () {
    this.setPreview('')
  }

  // Previews live in <product-media>, so they're reached as external elements
  // (data-colour-swatches-external-el) rather than this.els descendants.
  setPreview (colour) {
    if (this.activeColour === colour) return

    const previews = this.externalEls

    previews[this.activeColour]?.element?.setAttribute('aria-hidden', 'true')

    this.activeColour = colour

    previews[colour]?.element?.removeAttribute('aria-hidden')
  }
}

if (!customElements.get('colour-swatches')) {
  customElements.define('colour-swatches', ColourSwatches)
}
